import { Phone, MessageSquareText } from "lucide-react";
import { SITE } from "@/data/site";

export default function FloatingCTA() {
  return (
    <div className="fixed right-4 z-40 flex flex-col gap-3 bottom-24 lg:bottom-6" data-testid="floating-cta">
      <a href={SITE.phoneHref} data-testid="floating-call" aria-label="Call The VIN Verifier now"
        className="h-14 w-14 rounded-full bg-accent text-white shadow-[0_10px_30px_rgba(255,138,0,0.45)] flex items-center justify-center hover:scale-105 transition-transform">
        <Phone size={22} />
      </a>
      <a href={SITE.sms} data-testid="floating-sms" aria-label="Text The VIN Verifier"
        className="h-14 w-14 rounded-full bg-brand text-white shadow-[0_10px_30px_rgba(10,61,145,0.4)] flex items-center justify-center hover:scale-105 transition-transform">
        <MessageSquareText size={22} />
      </a>
    </div>
  );
}
